import React, { useCallback, useMemo, useRef } from "react";
import { ConnectButton } from "360dialog-connect-button";

export const DIALOG_PARTNER_ID = "Nog49UPA";
// v2 is the Integrated Onboarding at app.360dialog.com, the one that offers
// WhatsApp Login ("Do you have a Facebook account?" → no) to the customer.
export const DIALOG_CONNECT_VERSION = "v2";
// Route that links the granted channels with POST /link-whatsapp.
export const DIALOG_REDIRECT_PATH = "/success-link";

/**
 * The 360dialog Connect Button with iVentas' partner, onboarding version and
 * query fixed in one place.
 *
 * 360dialog-connect-button@1 rebuilds its core whenever `queryParameters`
 * changes identity and re-runs the redirect callback whenever `callback` or the
 * core change: with an inline object or function, every render of the page
 * would hand the same redirect to the callback again. Both are kept stable
 * here, so callers can pass inline callbacks.
 *
 * The redirect goes back to this same origin, so a Vercel preview returns to
 * itself instead of the URL configured globally in the Partner Hub.
 */
export const DialogConnectButton = ({ callback, ...props }) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const stableCallback = useCallback((data) => {
    if (callbackRef.current) callbackRef.current(data);
  }, []);

  const queryParameters = useMemo(
    () => ({
      plan_selection: "basic",
      redirect_url: `${window.location.origin}${DIALOG_REDIRECT_PATH}`,
    }),
    [],
  );

  return (
    <ConnectButton
      {...props}
      partnerId={DIALOG_PARTNER_ID}
      version={DIALOG_CONNECT_VERSION}
      queryParameters={queryParameters}
      callback={stableCallback}
    />
  );
};
